export * from './activity';
export * from './stamp';
export * from './common';
export * from './coupon';
export * from './user';
export * from './wepoints';
/** 分片上报elk参数 */
export const SEGMENT_REPORT = 'segmentReport=1';
/** 关闭elk上报 */
export const NO_REPORT = 'noreport=1';
